import { Component, Input, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FacebookService } from "src/app/services/social/facebook.service";

@Component({
  selector: "app-facebook-item",
  templateUrl: "./facebook-item.component.html",
  styleUrls: ["./facebook-item.component.css"],
})
export class FacebookItemComponent implements OnInit {
  reactions = {
    like: "👍",
    love: "❤️",
    care: "😍",
    haha: "😆",
    wow: "😮",
    sad: "😢",
    angry: "😠",
  };
  @Input() post: any = {};

  constructor(
    private facebookService: FacebookService,
    private toaster: ToastrService
  ) {}

  ngOnInit() {
    this.facebookService.repliedPost.subscribe((id) => {
      if (id === this.post.post_id) {
        this.post.is_handled = true;
      }
    });
  }

  getReaction(reaction: string) {
    return this.reactions[reaction];
  }

  getPostDetails(pageId: number, postId: number) {
    this.facebookService.fetchFacebookPost(pageId, postId).subscribe(
      (response: any) => {
        const { status_code, success, payload } = response;
        if (success && (status_code == 200 || status_code == 201)) {
          this.openPostModal(payload);
        }
      },
      (e) => {
        this.toaster.error("Cannot find post.");
      }
    );
  }

  openPostModal(post: object) {
    this.facebookService.postToView.next(post);
  }

  openReplyModal(post: object) {
    this.facebookService.postToReply.next(post);
  }
}
